var exports = {
  "iE": "VoiceChannelUserCount.module__wrapper___YmE5Vm",
  "VV": "VoiceChannelUserCount.module__users___YmE5Vm",
  "X5": "VoiceChannelUserCount.module__total___YmE5Vm",
};

module.exports = exports;
